import React, { useCallback, useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useForm, useFormState } from 'react-final-form';
import PatchListingContext from 'router/subrouters/ListingCreationWizard/providers/PatchListing/PatchListing.context';

import './EnquiryRequirementsField.styles.scss';

const NAME = 'isContextRequired';

type EnquiryRequirementsFieldProps = {
  className?: string;
};

const EnquiryRequirementsField: React.FC<EnquiryRequirementsFieldProps> = (
  props,
) => {
  const { className } = props;

  const { patchListingValue } = useContext(PatchListingContext);

  const classes = classNames('enquiry-requirements-field', className);

  const { change } = useForm();
  const { values } = useFormState();

  const isContextRequired = !!values?.[NAME];

  const { t } = useTranslation();

  const onChange = useCallback(
    (value: boolean) => {
      change(NAME, value);
      patchListingValue({ [NAME]: value });
    },
    [change, patchListingValue],
  );

  const getOption = useCallback(
    (value: boolean, label: string, description: string) => (
      <div
        className={classNames('clickable', {
          active: value === isContextRequired,
        })}
        onClick={() => onChange(value)}
      >
        <p>{label}</p>
        <p>{description}</p>
      </div>
    ),
    [isContextRequired, onChange],
  );

  return (
    <>
      <div className="lcw-custom-label-container">
        <h3>{t('enquiryRequirements')}</h3>
        <p>{t('enquiryRequirementsDescription')}</p>
      </div>

      <div className={classes}>
        {getOption(
          false,
          t('optional_UC'),
          t('buyersCanEnquireWithoutProvidingContext'),
        )}

        {getOption(true, t('required'), t('buyersMustIncludeContextToEnquire'))}
      </div>
    </>
  );
};

export default EnquiryRequirementsField;
